var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666672 2.33341C0.666672 1.41294 1.41286 0.666748 2.33334 0.666748H14C14.9205 0.666748 15.6667 1.41294 15.6667 2.33341V7.66511L15.2285 7.22556L15.2236 7.22069C13.7146 5.71809 10.9668 6.6798 10.9668 9.04562V9.46015C9.10294 10.0071 7.62907 10.9941 6.51168 12.2657C6.49191 12.2882 6.47226 12.3108 6.45274 12.3334H2.33334C1.41286 12.3334 0.666672 11.5872 0.666672 10.6667V2.33341ZM2.42484 3.26036C2.61708 2.91965 3.04912 2.79929 3.38983 2.99153L8.10533 5.65214C8.14345 5.67365 8.19005 5.67365 8.22818 5.65214L12.9437 2.99153C13.2844 2.79929 13.7164 2.91965 13.9087 3.26036C14.1009 3.60107 13.9805 4.03311 13.6398 4.22535L8.92433 6.88596C8.45412 7.15127 7.87938 7.15127 7.40917 6.88596L2.69368 4.22535C2.35297 4.03311 2.2326 3.60107 2.42484 3.26036Z",
    fill: "#001B53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8813 10.8841V8.83146C12.8813 8.24223 13.5896 7.9443 14.0028 8.3614L17.9748 12.4002C18.2306 12.6584 18.2306 13.0755 17.9748 13.3337L14.0028 17.3726C13.5896 17.7897 12.8813 17.4984 12.8813 16.9091V14.7903C9.60191 14.7903 7.30636 15.8496 5.66667 18.1667C6.32255 14.8565 8.29017 11.5462 12.8813 10.8841Z",
    fill: "#001B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailShare);
export default __webpack_public_path__ + "static/media/emailShare.c864201b2f0f091ce985c95cd9ce9755.svg";
export { ForwardRef as ReactComponent };